import customerPaymentModesServiceGen from "./generated/customerPaymentModesServiceGen";

class customerPaymentModesService extends customerPaymentModesServiceGen {
}

export default customerPaymentModesService;